import api from '../api';

class DataServiceAdminPermission {
  getMine() {
    return api.get('admin-permissions/me');
  }

  getByUser(idUser) {
    return api.get(`admin-permissions/users/${idUser}`);
  }

  updateByUser(idUser, data) {
    return api.put(`admin-permissions/users/${idUser}`, data);
  }
}

export default new DataServiceAdminPermission();
